module.exports = __webpack_public_path__ + "fonts/SuisseIntl-Regular.c7060fc.woff2";